export const LANDING = {
  page: "landing-china-page",
  logo: "brand-logo",
  headline: "headline",
  subheadline: "subheadline",
  audioCue: "audio-cue-banner",
  videoSection: "video-section",
  vturbPlayer: "vturb-player",
  ctaPrimary: "cta-primary",
  ctaSecondary: "cta-secondary",
  formIntro: "form-intro-text",
  leadDialog: "lead-dialog",
  leadDialogOpen: "open-lead-dialog",
  inputName: "input-name",
  inputEmail: "input-email",
  inputWhatsapp: "input-whatsapp",
  submitForm: "submit-lead-form",
  formError: "form-error-message",
  footer: "site-footer",
};

export const THANKYOU = {
  page: "thank-you-page",
  heading: "thank-you-heading",
  backHome: "thank-you-back-home",
};
